export default function initAccordionPromo() {
  const accordionPromos = document.querySelectorAll(".js-accordion-promo");

  if (accordionPromos) {
    accordionPromos.forEach((accordion) => {
      const toggleBtns = accordion.querySelectorAll(
        ".accordion-promo__toggle-btn",
      );

      const panels = accordion.querySelectorAll(".accordion-promo__panel");

      const parents = accordion.querySelectorAll(
        ".accordion-promo__promo-right",
      );

      const hideAllPanels = () => {
        [...parents].forEach((parent) => {
          if (parent.classList.contains("open")) {
            parent.classList.remove("open");
          }
        });

        [...toggleBtns].forEach((btn) => {
          btn.setAttribute("aria-expanded", false);
        });

        [...panels].forEach((panel) => {
          if (panel.classList.contains("open")) {
            panel.classList.remove("open");
          }
        });
      };

      [...toggleBtns].forEach((btn) => {
        btn.addEventListener("click", () => {
          const panel = btn.nextElementSibling;
          const parent = btn.parentElement;

          if (btn.getAttribute("aria-expanded") === "false") {
            hideAllPanels();

            btn.setAttribute("aria-expanded", true);
            panel.classList.add("open");
            parent.classList.add("open");
          } else {
            btn.setAttribute("aria-expanded", false);
            panel.classList.remove("open");
            parent.classList.remove("open");
          }
        });
      });
    });
  }
}
